import { validateGooglePayCardAuthMethodArray, } from "./GooglePayCardAuthMethod";
import { validateGooglePayCardNetworkArray, } from "./GooglePayCardNetwork";
import { validateGooglePayTotalPriceStatus } from "./GooglePayTotalPriceStatus";
import { validateGooglePayPaymentMethodType } from "./GooglePayPaymentMethodType";
import { validateGooglePayShippingAddressParameters, } from "./GooglePayShippingAddressParameters";
import { validateGooglePayShippingOptionParameters, } from "./GooglePayShippingOptionParameters";
import { validateGooglePayBillingAddressParameters, } from "./GooglePayBillingAddressParameters";
import { isIso4217, isLocaleValid, isString } from "@payair/e-com-common-sdk/core/Validators";
import { validateParam, isBoolean, MUST_BE_STRING, MUST_BE_BOOLEAN } from "../core/Helpers";
/**
 * Payair Google Pay transaction options type.
 */
var GooglePayInitParams = /** @class */ (function () {
    function GooglePayInitParams() {
    }
    return GooglePayInitParams;
}());
export { GooglePayInitParams };
/** @internal */
export var validateGooglePayInitParams = function (googlePayInitParams) {
    var errorMessage = [];
    if (!googlePayInitParams) {
        errorMessage.push("googlePayInitParams is not defined");
        return errorMessage;
    }
    // totalAmount!: string
    var totalAmount = validateParam(googlePayInitParams.totalAmount, "totalAmount", isString(googlePayInitParams.totalAmount), true, MUST_BE_STRING);
    totalAmount && errorMessage.push(totalAmount);
    // totalAmountLabel!: string
    var totalAmountLabel = validateParam(googlePayInitParams.totalAmountLabel, "totalAmountLabel", isString(googlePayInitParams.totalAmountLabel), true, MUST_BE_STRING);
    totalAmountLabel && errorMessage.push(totalAmountLabel);
    // locale!: string
    var locale = validateParam(googlePayInitParams.locale, "locale", isLocaleValid(googlePayInitParams.locale), true, " Valid example: en_GB, sv_SE. See docs for more info.");
    locale && errorMessage.push(locale);
    // currencyCode!: string
    var currencyCode = validateParam(googlePayInitParams.currencyCode, "currencyCode", isIso4217(googlePayInitParams.currencyCode), true, MUST_BE_STRING);
    currencyCode && errorMessage.push(currencyCode);
    // transactionId!: string
    var transactionId = validateParam(googlePayInitParams.transactionId, "transactionId", isString(googlePayInitParams.transactionId), true, MUST_BE_STRING);
    transactionId && errorMessage.push(transactionId);
    // merchantId!: string
    var merchantId = validateParam(googlePayInitParams.merchantId, "merchantId", isString(googlePayInitParams.merchantId), true, MUST_BE_STRING);
    merchantId && errorMessage.push(merchantId);
    // merchantName!: string
    var merchantName = validateParam(googlePayInitParams.merchantName, "merchantName", isString(googlePayInitParams.merchantName), true, MUST_BE_STRING);
    merchantName && errorMessage.push(merchantName);
    // pspName!: string
    var pspName = validateParam(googlePayInitParams.pspName, "pspName", isString(googlePayInitParams.pspName), true, MUST_BE_STRING);
    pspName && errorMessage.push(pspName);
    // environment!: "QA" | "PROD"
    var environment = validateParam(googlePayInitParams.environment, "environment", googlePayInitParams.environment === "QA" || googlePayInitParams.environment === "PROD", true, " Must be QA or PROD");
    environment && errorMessage.push(environment);
    // totalPriceStatus?: GooglePayTotalPriceStatus
    if (googlePayInitParams.totalPriceStatus) {
        var validationResult = validateGooglePayTotalPriceStatus(googlePayInitParams.totalPriceStatus);
        var totalPriceStatus = validateParam(googlePayInitParams.totalPriceStatus, "totalPriceStatus", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        totalPriceStatus && errorMessage.push(totalPriceStatus);
    }
    // paymentMethodType?: GooglePayPaymentMethodType
    if (googlePayInitParams.paymentMethodType) {
        var validationResult = validateGooglePayPaymentMethodType(googlePayInitParams.paymentMethodType);
        var paymentMethodType = validateParam(googlePayInitParams.paymentMethodType, "paymentMethodType", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        paymentMethodType && errorMessage.push(paymentMethodType);
    }
    // allowedCardNetworks?: GooglePayCardNetwork[]
    if (googlePayInitParams.allowedCardNetworks) {
        var validationResult = validateGooglePayCardNetworkArray(googlePayInitParams.allowedCardNetworks);
        var allowedCardNetworks = validateParam(googlePayInitParams.allowedCardNetworks, "allowedCardNetworks", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        allowedCardNetworks && errorMessage.push(allowedCardNetworks);
    }
    // allowedCardAuthMethods?: GooglePayCardAuthMethod[]
    if (googlePayInitParams.allowedCardAuthMethods) {
        var validationResult = validateGooglePayCardAuthMethodArray(googlePayInitParams.allowedCardAuthMethods);
        var allowedCardAuthMethods = validateParam(googlePayInitParams.allowedCardAuthMethods, "allowedCardAuthMethods", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        allowedCardAuthMethods && errorMessage.push(allowedCardAuthMethods);
    }
    // gateway?: string
    var gateway = validateParam(googlePayInitParams.gateway, "gateway", isString(googlePayInitParams.gateway), false, MUST_BE_STRING);
    gateway && errorMessage.push(gateway);
    // gatewayMerchantId?: string
    var gatewayMerchantId = validateParam(googlePayInitParams.gatewayMerchantId, "gatewayMerchantId", isString(googlePayInitParams.gatewayMerchantId), false, MUST_BE_STRING);
    gatewayMerchantId && errorMessage.push(gatewayMerchantId);
    // billingAddressRequired?: boolean
    var billingAddressRequired = validateParam(googlePayInitParams.billingAddressRequired, "billingAddressRequired", isBoolean(googlePayInitParams.billingAddressRequired), false, MUST_BE_BOOLEAN);
    billingAddressRequired && errorMessage.push(billingAddressRequired);
    // billingAddressParameters?: GooglePayBillingAddressParameters
    if (googlePayInitParams.billingAddressParameters) {
        var validationResult = validateGooglePayBillingAddressParameters(googlePayInitParams.billingAddressParameters);
        var billingAddressParameters = validateParam(googlePayInitParams.billingAddressParameters, "billingAddressParameters", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        billingAddressParameters && errorMessage.push(billingAddressParameters);
    }
    // shippingAddressRequired?: boolean
    var shippingAddressRequired = validateParam(googlePayInitParams.shippingAddressRequired, "shippingAddressRequired", isBoolean(googlePayInitParams.shippingAddressRequired), false, MUST_BE_BOOLEAN);
    shippingAddressRequired && errorMessage.push(shippingAddressRequired);
    // shippingAddressParameters?: GooglePayShippingAddressParameters
    if (googlePayInitParams.shippingAddressParameters) {
        var validationResult = validateGooglePayShippingAddressParameters(googlePayInitParams.shippingAddressParameters);
        var shippingAddressParameters = validateParam(googlePayInitParams.shippingAddressParameters, "shippingAddressParameters", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        shippingAddressParameters && errorMessage.push(shippingAddressParameters);
    }
    // shippingOptionRequired?: boolean
    var shippingOptionRequired = validateParam(googlePayInitParams.shippingOptionRequired, "shippingOptionRequired", isBoolean(googlePayInitParams.shippingOptionRequired), false, MUST_BE_BOOLEAN);
    shippingOptionRequired && errorMessage.push(shippingOptionRequired);
    // shippingOptionParameters?: GooglePayShippingOptionParameters
    if (googlePayInitParams.shippingOptionParameters) {
        var validationResult = validateGooglePayShippingOptionParameters(googlePayInitParams.shippingOptionParameters);
        var shippingOptionParameters = validateParam(googlePayInitParams.shippingOptionParameters, "shippingOptionParameters", validationResult === null, false, " ".concat(validationResult ? validationResult : ""));
        shippingOptionParameters && errorMessage.push(shippingOptionParameters);
    }
    // enablePromoCodes?: boolean
    var enablePromoCodes = validateParam(googlePayInitParams.enablePromoCodes, "enablePromoCodes", isBoolean(googlePayInitParams.enablePromoCodes), false, MUST_BE_BOOLEAN);
    enablePromoCodes && errorMessage.push(enablePromoCodes);
    // emailRequired?: boolean
    var emailRequired = validateParam(googlePayInitParams.emailRequired, "emailRequired", isBoolean(googlePayInitParams.emailRequired), false, MUST_BE_BOOLEAN);
    emailRequired && errorMessage.push(emailRequired);
    // onPaymentDataChanged?: function
    var onPaymentDataChanged = validateParam(googlePayInitParams.onPaymentDataChanged, "onPaymentDataChanged", typeof googlePayInitParams.onPaymentDataChanged === "function", false, " Must be a function");
    onPaymentDataChanged && errorMessage.push(onPaymentDataChanged);
    return errorMessage;
};
